import axios from 'axios'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  withCredentials: false, // `withCredentials` 表示跨域请求时是否需要使用凭证
  timeout: 30 * 1000
})
// 请求拦截器
request.interceptors.request.use(config => {
  return config
}, error => {
  Promise.reject(error)
})
// 响应拦截器
request.interceptors.response.use(res => {
  const resData = res.data
  return resData
},error => {
  return Promise.reject(error)
})

export default request
